import { strTitlelize } from 'src/helpers';
import { FormDataFields, IdDealer, IdVehicle, Installation } from 'src/types';

export const getCemInstallationName = (
	installation: Installation,
	idDealer: IdDealer,
) => {
	return strTitlelize(
		installation?.VGED_CommercialName__c
			? installation.VGED_CommercialName__c
			: idDealer?.VGED_CommercialName__c
			? idDealer.VGED_CommercialName__c
			: '',
	);
};

export const getCemCarlineName = (
	idVehicle: IdVehicle,
	fields: FormDataFields,
	dpsData: any,
) => {
	if (fields.modeloList?.name) {
		return fields.modeloList?.name;
	} else if (idVehicle.VGED_ModelGroup__c) {
		return idVehicle.VGED_ModelGroup__c;
	} else if (dpsData.model) {
		return dpsData.model;
	} else {
		return 'Volkswagen';
	}
};
